<p>
  {{ "internet.settings.modem-choice.description" | translate }}
</p>
<a
  [routerLink]="['/details/internet', circuitId, 'modem-choice']"
  class="rs-btn"
>
  {{ "internet.settings.modem-choice.button" | translate }}
</a>
